var map = {
	"./country/de.json": "9b52",
	"./country/default.json": "b8b0",
	"./de.json": "6ce2",
	"./default.json": "369a",
	"./module-admin/de.json": "91f7",
	"./module-admin/default.json": "7af8",
	"./module-visitor/de.json": "2fda",
	"./module-visitor/default.json": "38ee"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";